import React, { useEffect } from 'react';
import Image from '../../../components/AppImage';

import Button from '../../../components/ui/Button';

const ImageZoomModal = ({ isOpen, imageSrc, imageAlt, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="relative max-w-7xl max-h-full">
        {/* Close Button */}
        <Button
          variant="ghost"
          iconName="X"
          iconSize={24}
          onClick={onClose}
          className="absolute -top-12 right-0 text-white hover:bg-white/20 z-10"
        />
        
        {/* Image Container */}
        <div className="relative bg-white rounded-lg overflow-hidden shadow-elevation-2 max-h-[90vh] max-w-[90vw]">
          <Image
            src={imageSrc}
            alt={imageAlt}
            className="w-full h-full object-contain"
          />
          
          {/* Image Caption */}
          <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white p-4">
            <p className="text-sm font-medium">{imageAlt}</p>
            <p className="text-xs text-white/80 mt-1">
              Click outside or press ESC to close
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageZoomModal;